// Using example from Tailwind UI: https://tailwindui.com/components/application-ui/elements/dropdowns
import { Fragment } from "react";
import { Menu, Transition } from "@headlessui/react";
import Image from "next/image";
import Link from "next/link";
import {
  FaChevronDown,
  FaFilter,
  FaImages,
  FaPhotoVideo,
  FaTiktok,
  FaVideo,
} from "react-icons/fa";
import {
  BsDisplay,
  BsPhone,
  BsDisplayFill,
  BsPhoneFill,
  BsSortNumericDown,
  BsSortNumericDownAlt,
  BsSortNumericUp,
  BsSortNumericUpAlt,
  BsStars,
  BsGraphUp,
} from "react-icons/bs";
import { BiDevices, BiSortAlt2 } from "react-icons/bi";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function FeedSort({
  onClick,
  current,
  isSearch,
  hiddenResponsive,
}) {
  return (
    <Menu
      as="div"
      className={`relative inline-block text-left md:z-[100] z-[40] ${
        hiddenResponsive && "md:hidden"
      }`}
    >
      <div>
        <Menu.Button
          className={`inline-flex items-center flex-row font-BreezeButton gap-x-2 text-xs leading-tight px-4 py-2 bg-gray-200 hover:bg-gray-300 active:shadow-lg transition-colors duration-500 ease-in-out uppercase text-sp text-black rounded-full`}
        >
          <BiSortAlt2 className="w-6 md:w-8 h-4 md:h-6" />
        </Menu.Button>
      </div>

      <Transition
        as={Fragment}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right absolute md:right-0 py-2 md:pb-1 w-56 rounded-md shadow-lg bg-slate-800 ring-1 ring-black ring-opacity-5 focus:outline-none">
          <div className="py-1">
            {isSearch && (
              <Menu.Item key="relevance">
                {({ active }) => (
                  <button
                    className={`${classNames(
                      active
                        ? "bg-gray-600 text-slate-100"
                        : "text-slate-100 hover:bg-gray-600",
                      "block px-4 py-2 text-sm"
                    )} flex flex-row gap-x-2 items-center w-full`}
                    onClick={() => {
                      onClick("relevance");
                    }}
                  >
                    <BsGraphUp className="w-6 h-6" />
                    Relevance
                  </button>
                )}
              </Menu.Item>
            )}
            <Menu.Item key="unsorted">
              {({ active }) => (
                <button
                  className={`${classNames(
                    active
                      ? "bg-gray-600 text-slate-100"
                      : "text-slate-100 hover:bg-gray-600",
                    "block px-4 py-2 text-sm"
                  )} flex flex-row gap-x-2 items-center w-full`}
                  onClick={() => {
                    onClick("newest-first");
                  }}
                >
                  <BsSortNumericDownAlt className="w-6 h-6" />
                  Newest to oldest
                </button>
              )}
            </Menu.Item>
            <Menu.Item key="videos">
              {({ active }) => (
                <button
                  className={`${classNames(
                    active
                      ? "bg-gray-600 text-slate-100"
                      : "text-slate-100 hover:bg-gray-600",
                    "block px-4 py-2 text-sm"
                  )} flex flex-row gap-x-2 items-center w-full`}
                  onClick={() => {
                    onClick("chronological-ascend");
                  }}
                >
                  <BsSortNumericUpAlt className="w-6 h-6" />
                  Oldest to newest
                </button>
              )}
            </Menu.Item>
            <Menu.Item key="shorts">
              {({ active }) => (
                <button
                  className={`${classNames(
                    active
                      ? "bg-gray-600 text-slate-100"
                      : "text-slate-100 hover:bg-gray-600",
                    "block px-4 py-2 text-sm"
                  )} flex flex-row gap-x-2 items-center w-full`}
                  onClick={() => {
                    onClick("most-viewed");
                  }}
                >
                  <BsStars className="w-6 h-6" />
                  Most viewed
                </button>
              )}
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
